import React, { useState, useEffect } from 'react'
import Footer from '../components/Footer'
import CallToAction from '../components/CallToAction'
import image1 from '../assets/image3.png'
import { MdKeyboardDoubleArrowDown } from "react-icons/md";
import building1 from '../assets/building1.png'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import CountUp from 'react-countup'
import { useInView } from 'react-intersection-observer'
import { animateScroll as scroll } from 'react-scroll'

const About = () => {
  const [loading, setLoading] = useState(true);
  const { ref: statsRef, inView: statsInView } = useInView({ triggerOnce: true, threshold: 0.3 });

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  const scrollToNextSection = () => {
    const viewportHeight = window.innerHeight - 98;
    scroll.scrollTo(viewportHeight, {
      duration: 1000,
      smooth: true,
      spy: true,
      offset: -98 // Account for navbar height
    });
  };

  return (
    <div>
        <section className="relative h-[calc(100vh-98px)] p-12 bg-gray-900 mt-24 overflow-hidden md:mx-14">
            <div className="absolute inset-0 bg-cover bg-center bg-no-repeat">
                <img src={image1} alt="Construction Background" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-[#003A7D] bg-opacity-10"></div>
            </div>
            
            {/* <div className="relative z-10 flex flex-col justify-end items-start h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {loading ? (
                    <Skeleton height={60} width={350} style={{ marginBottom: 32, borderRadius: 8 }} />
                ) : (
                    <h1 className="text-4xl md:text-6xl font-bold text-white mb-32 leading-tight">
                        Reliable <br /> Construction. <br />Lasting Impact.
                    </h1>
                )}
            </div> */}
            <div 
                className="absolute z-30 bottom-8 right-8 text-white animate-pulse cursor-pointer hover:scale-110 transition-transform duration-300"
                onClick={scrollToNextSection}>
                <MdKeyboardDoubleArrowDown size={80} className='animate-bounce'/>
          </div>
        </section>
        <section className="px-6 py-12 lg:py-20 lg:px-20 bg-white">
            <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
                {/* Left: Text Content */}
                <div>
                {loading ? (
                    <>
                        <Skeleton height={40} width={180} style={{ marginBottom: 24, borderRadius: 8 }} />
                        <Skeleton count={3} height={20} width={500} style={{ marginBottom: 8, borderRadius: 8 }} />
                        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
                            {Array.from({ length: 4 }).map((_, idx) => (
                                <div key={idx}>
                                    <Skeleton height={32} width={60} style={{ margin: '0 auto', borderRadius: 8 }} />
                                    <Skeleton height={16} width={100} style={{ margin: '8px auto 0', borderRadius: 8 }} />
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <>
                        <h2 className="text-4xl font-bold leading-tight text-[#0037AD] uppercase">
                            About
                        </h2>
                        <p className="mt-6 text-black leading-relaxed">
                        YETWINS CONISTRUCTION PLC is a reputable construction company operating in Addis Ababa, Ethiopia, that has been in business for over 15 years serving finishing options including general construction, design & build, renovation, civil works, and infrastructure. We also rent equipment to help get the job done correctly. With a great team and a passion for quality, YETWINS is anchored in purpose, apply precision, built for partnership.
                        </p>

                        {/* Stats */}
                        <div ref={statsRef} className="mt-10 grid grid-cols-2 sm:grid-cols-2 gap-6 text-center">
                            <div>
                            <p className="text-2xl font-bold text-[#0037AD]">{statsInView ? <CountUp end={15} duration={4.5} /> : 0}+</p>
                            <p className="text-sm text-black mt-1 uppercase tracking-wide">Years of Experience</p>
                            </div>
                            <div>
                            <p className="text-2xl font-bold text-[#0037AD]">{statsInView ? <CountUp end={450} duration={4.5} /> : 0}+</p>
                            <p className="text-sm text-black mt-1 uppercase tracking-wide">Completed Projects</p>
                            </div>
                            <div>
                            <p className="text-2xl font-bold text-[#0037AD]">{statsInView ? <CountUp end={98} duration={4.5} /> : 0}%</p>
                            <p className="text-sm text-black mt-1 uppercase tracking-wide">Satisfied Clients</p>
                            </div>
                            <div>
                            <p className="text-2xl font-bold text-[#0037AD]">{statsInView ? <CountUp end={8} duration={4.5} /> : 0}+</p>
                            <p className="text-sm text-black mt-1 uppercase tracking-wide">Awards & Recognition</p>
                            </div>
                        </div>
                    </>
                )}
                </div>

                {/* Right: Image */}
                <div>
                {loading ? (
                    <Skeleton className="w-full h-64 rounded-md" style={{ height: '256px', borderRadius: 8 }} />
                ) : (
                    <img src={building1} alt="Office Building" className="w-full h-auto" />
                )}
                </div>
            </div>
        </section>
        <CallToAction />
        <Footer />
    </div>
  )
}

export default About